import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./assets/eds-styles.min.css";
import "@gehc-eds-react/eds-navigation-side";
import "@gehc-eds-react/eds-masthead";
import "@gehc-eds-react/eds-icon";
import '@gehc-eds-react/eds-button';
import '@gehc-eds-react/eds-system-notification';
import '@eds2-alpha1-react/eds-card';
import '@gehc-eds-react/eds-tabs';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
